import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
    selector: 'pp-account-user-management-placeholder',
    templateUrl: './account-user-management-placeholder.component.html',
    styleUrls: ['./account-user-management-placeholder.component.scss'],
    standalone: false
})
export class AccountUserManagementPlaceholderComponent implements OnInit, OnChanges {
  @Input() ppNumberOfLines: number = 6;
  @Input() ppShowEndElement: boolean = true;

  linesArray: number[];

  ngOnInit(): void {
    this.fillLinesArray();
  }

  ngOnChanges(): void {
    this.fillLinesArray();
  }

  private fillLinesArray(): void {
    this.linesArray = new Array(this.ppNumberOfLines);
  }
}
